module.exports = __webpack_public_path__ + "media/recipes/138-c5cda2d0.png";